import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import Icon from '../AppIcon';
import Button from './Button';

const ThemeToggle = ({ variant = 'outline', size = 'sm', showLabel = true, className = '' }) => {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleTheme}
      className={`flex items-center space-x-2 ${className}`}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      <Icon 
        name={isDark ? 'Sun' : 'Moon'} 
        size={16} 
        className="transition-transform duration-200"
      />
      {showLabel && (
        <span className="capitalize">
          {isDark ? 'Light' : 'Dark'} Mode
        </span>
      )}
    </Button>
  );
};

export default ThemeToggle;